import React from "react";

import {
  ClearButton,
  ClearIcon,
  Input,
  SearchIcon,
  SearchWrapper,
} from "./styles";
import { SearchInputProps } from "./types";

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  disabled = false,
  className,
  autoFocus = false,
  "aria-label": ariaLabel,
}) => {
  const showClear = value.length > 0 && !disabled;

  return (
    <SearchWrapper className={className}>
      <SearchIcon />
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        aria-label={ariaLabel ?? placeholder}
      />
      {showClear && (
        <ClearButton size="small" onClick={onClear} aria-label="Clear search">
          <ClearIcon />
        </ClearButton>
      )}
    </SearchWrapper>
  );
};
